import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import isEmail from 'validator/es/lib/isEmail';
import isURL from 'validator/es/lib/isURL';
import {
  hasMinimumLength, removeEmpty, filterWithMinimumLength, isPlainObject,
} from '@/utils/resultsHelper';
import MarkdownRender from '../text-editors/MarkdownRender';
import MarkdownLinksCellPopup from './MarkdownLinksCellPopup';

const safeNamedList = (items) => {
  if (Array.isArray(items)) {
    const [name] = items;
    if (isPlainObject(name)) {
      return items;
    }
    return items.map((item) => ({ name: item }));
  } if (isPlainObject(items)) {
    return [items];
  }
  return [{ name: items }];
};

const formattedLink = ({
  name, text, url, link,
}) => {
  const [markdownText] = filterWithMinimumLength([name, text, url, link]);
  const [markdownLink] = filterWithMinimumLength([url, link, name, text]);

  if (isPlainObject(markdownLink) || Array.isArray(markdownLink) || !hasMinimumLength(markdownLink)) { return null; }
  if (isEmail(markdownLink)) { return `- [${markdownText}](mailto:${markdownLink})`; }
  if (isURL(markdownLink)) { return `- [${markdownText}](${markdownLink})`; }
  if (markdownText === markdownLink) { return `- ${markdownText}`; }

  return `- ${markdownText}, ${markdownLink}`;
};

const formattedLinks = (items) => removeEmpty([...new Set(safeNamedList(items).map((item) => formattedLink(item)))]);

const MarkdownLinksCell = ({ className, items, theme }) => {
  const links = formattedLinks(items || []);
  return (
    <Table.Cell className={clsx('aridhia-markdown-links-cell', className)}>
      <MarkdownRender value={links.slice(0, 3).join('\n')} className="aridhia-markdown-links-cell--list" />
      {links.length > 3 && (<MarkdownLinksCellPopup links={links} theme={theme} />)}
    </Table.Cell>
  );
};

export default MarkdownLinksCell;
